"use client";

import { useEffect, useState } from "react"

export function useIsDesktop(breakpoint = 768) {
  const [isMounted, setIsMounted] = useState(false)
  const [isDesktop, setIsDesktop] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= breakpoint)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [breakpoint])

  return { isMounted, isDesktop }
}
